import React, {
  useState,
} from 'react';
import {
  disableBodyScroll,
  enableBodyScroll,
} from 'body-scroll-lock';
import Tour from 'reactour';

import Helper from './Helper';

type Props = {
  tourSteps: any[],
  handleOnPrev: { (): void },
  handleOnNext: { (): void },
};

const DashboardTour = ({
  tourSteps,
  handleOnPrev,
  handleOnNext,
}: Props) => {
  const [isTourOpen, setOpen] = useState(true);

  return (
    <Tour
      isOpen={isTourOpen}
      steps={tourSteps}
      startAt={tourSteps.findIndex(s => !s.isCompleted)}
      closeWithMask={false}
      showCloseButton={false}
      onAfterOpen={(target) => {
        disableBodyScroll(target);
        document.body.classList.add('opened_tour');
      }}
      onBeforeClose={(target) => {
        enableBodyScroll(target);
        document.body.classList.remove('opened_tour');
      }}
      onRequestClose={() => setOpen(false)}
      showNavigationNumber={false}
      showNumber={false}
      rounded={8}
      maskSpace={0}
      disableInteraction
      maskClassName="mask"
      className="helper"
      CustomHelper={props => Helper({
        handleOnPrev,
        handleOnNext,
        tourSteps,
        ...props,
      })}
    />
  );
};

export default DashboardTour;
